import { useEffect } from 'react';

const usePreloadAssets = (assets, setPreloadedAssets) => {
  useEffect(() => {
    if (!Array.isArray(assets) || assets.length === 0) return;

    try {
      const imageCache = {};
      const soundCache = {};

      assets.forEach((item) => {
        // Handle image
        if (item.imageUrl) {
          if (typeof item.imageUrl === 'object' && item.imageUrl.default) {
            imageCache[item.imageUrl.default] = true;
          } else if (typeof item.imageUrl === 'string') {
            const img = new Image();
            img.src = item.imageUrl;
            img.onerror = () => console.warn('Failed to preload image:', item.imageUrl);
            imageCache[item.imageUrl] = img;
          }
        }

        // Handle sound
        if (item.inSound) {
          try {
            const audio = new Audio(item.inSound);
            audio.preload = 'auto';
            audio.onerror = () => console.warn('Failed to preload audio:', item.inSound);
            soundCache[item.inSound] = audio;
          } catch (err) {
            console.error('Invalid audio URL:', item.inSound, err);
          }
        }
      });

      const preloadedAssets = { images: imageCache, sounds: soundCache };
      setPreloadedAssets(preloadedAssets);
    } catch (err) {
      console.error('usePreloadAssets error:', err);
    }
  }, [assets, setPreloadedAssets]);
};

export default usePreloadAssets;